import { graphql } from 'react-relay';
import { postStatusUpdater } from '../updaters.utils';
import { genericMutation } from '../utils';
import type { BatchPostMutation_EmptyTrash_Mutation } from './__generated__/BatchPostMutation_EmptyTrash_Mutation.graphql';
import type {
  BatchPostMutation_Update_Mutation,
  ZnglyPostTypeEnum,
} from './__generated__/BatchPostMutation_Update_Mutation.graphql';

const BatchPostMutation = graphql`
  mutation BatchPostMutation_Update_Mutation($input: BatchPostMutationInput!) {
    batchPostMutation(input: $input) {
      ids
      message
    }
  }
`;

export type { BatchPostMutation_Update_Mutation } from './__generated__/BatchPostMutation_Update_Mutation.graphql';
export const batchPostMutation = genericMutation<BatchPostMutation_Update_Mutation>((variables) => ({
  mutation: BatchPostMutation,
  updater: (store, data) => {
    postStatusUpdater(
      store,
      (data?.batchPostMutation?.ids as string[]) ?? [],
      variables.input.postType as ZnglyPostTypeEnum,
      variables.input.status
    );
  },
}));

const EmptyTrashMutation = graphql`
  mutation BatchPostMutation_EmptyTrash_Mutation($input: EmptyTrashInput!) {
    emptyTrash(input: $input) {
      ids
      message
    }
  }
`;

export type { BatchPostMutation_EmptyTrash_Mutation } from './__generated__/BatchPostMutation_EmptyTrash_Mutation.graphql';
export const emptyTrashMutation = genericMutation<BatchPostMutation_EmptyTrash_Mutation>((variables) => ({
  mutation: EmptyTrashMutation,
  updater: (store, data) => {
    // delete the nodes from the store
    for (const id of (data?.emptyTrash?.ids as string[]) ?? []) {
      store.delete(id);
    }
  },
}));
